/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserFacilityAccess } from './UserFacilityAccess';
import {
    UserFacilityAccessFromJSON,
    UserFacilityAccessFromJSONTyped,
    UserFacilityAccessToJSON,
    UserFacilityAccessToJSONTyped,
} from './UserFacilityAccess';

/**
 * 
 * @export
 * @interface FindAllUserFacilityAccess200Response
 */
export interface FindAllUserFacilityAccess200Response {
    /**
     * 
     */
    data?: Array<UserFacilityAccess>;
}

/**
 * Check if a given object implements the FindAllUserFacilityAccess200Response interface.
 */
export function instanceOfFindAllUserFacilityAccess200Response(value: object): value is FindAllUserFacilityAccess200Response {
    return true;
}

export function FindAllUserFacilityAccess200ResponseFromJSON(json: any): FindAllUserFacilityAccess200Response {
    return FindAllUserFacilityAccess200ResponseFromJSONTyped(json, false);
}

export function FindAllUserFacilityAccess200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllUserFacilityAccess200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(UserFacilityAccessFromJSON)),
    };
}

export function FindAllUserFacilityAccess200ResponseToJSON(json: any): FindAllUserFacilityAccess200Response {
    return FindAllUserFacilityAccess200ResponseToJSONTyped(json, false);
}

export function FindAllUserFacilityAccess200ResponseToJSONTyped(value?: FindAllUserFacilityAccess200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(UserFacilityAccessToJSON)),
    };
}

